import primerPdf from "../components/qrcode/Primer Data Sheet.pdf";
import acrylicPdf from "../components/qrcode/Acrylic Data Sheet.pdf";
import cushionPdf from "../components/qrcode/Cushion Data Sheet.pdf";
import surfacerPdf from "../components/qrcode/SURFACER Data Sheet.pdf";
import protectionPdf from "../components/qrcode/Protection layer Data Sheet.pdf";
import grassPdf from "../components/qrcode/Grass.pdf";

export const QR_CODE_ITEMS = [
  {
    id: "primer",
    title: "Primer",
    qrUrl:
      "https://caf-sports.com/static/media/Primer.73cccf8dd7bb401754ca.pdf",
    downloadUrl: primerPdf,
    fileName: "Primer.pdf",
  },
  {
    id: "acrylic",
    title: "Acrylic",
    qrUrl:
      "https://caf-sports.com/static/media/Acrylic.0f6a3899a3b8254875c1.pdf",
    downloadUrl: acrylicPdf,
    fileName: "Acrylic.pdf",
  },
  {
    id: "cushion",
    title: "Cushion",
    qrUrl:
      "https://caf-sports.com/static/media/Cushion.85dd869146b10d5d088e.pdf",
    downloadUrl: cushionPdf,
    fileName: "Cushion.pdf",
  },
  {
    id: "surfacer",
    title: "SURFACER",
    qrUrl:
      "https://caf-sports.com/static/media/SURFACER.68d7c445d44848322155.pdf",
    downloadUrl: surfacerPdf,
    fileName: "SURFACER.pdf",
  },
  {
    id: "protection",
    title: "Protection layer",
    qrUrl:
      "https://caf-sports.com/static/media/ProtectionLayer.5a736bf62a424e151d04.pdf",
    downloadUrl: protectionPdf,
    fileName: "Protection layer.pdf",
  },
  {
    id: "grass",
    title: "Grass Adhesive",
    qrUrl: "https://caf-sports.com/static/media/Grass.pdf",
    downloadUrl: grassPdf,
    fileName: "Grass Adhesive.pdf",
  },
];
